import {
  clearHopRegistrationDobInputErrors,
  getBirthdateValidationError,
} from '../../account-details/js/validate-birthdate';

export const submitButtonValidationEvent = 'hopRegistration:validateSubmitButton';

export const hopRegistrationPhoneInputIds = ['HomePhone', 'MobilePhone'];

function isCheckboxChecked(id) {
  const checkbox = document.getElementById(id);
  if (!checkbox) {
    return true;
  }

  if (checkbox.tagName === 'AT-CHECKBOX') {
    const input = checkbox.querySelector('input[type="checkbox"]');
    if (input) {
      return input.checked;
    }

    if (typeof checkbox.checked === 'boolean') {
      return checkbox.checked;
    }

    return false;
  }

  if (checkbox.type === 'checkbox') {
    return checkbox.checked;
  }

  return true;
}

function isVisibleFormField(field) {
  if (field.type === 'hidden' || field.type === 'checkbox') {
    return false;
  }

  if (field.closest('[hidden]')) {
    return false;
  }

  const hasLayout = field.offsetWidth > 0 || field.offsetHeight > 0 || field.getClientRects().length > 0;
  if (hasLayout) {
    return true;
  }

  const style = window.getComputedStyle?.(field);
  if (!style) {
    return true;
  }

  return style.display !== 'none' && style.visibility !== 'hidden';
}

export function isDobDisclaimerMandatoryAndUnchecked() {
  if (!document.getElementById('dob-disclaimer-field')) {
    return false;
  }

  return !isCheckboxChecked('dob-integrity-disclaimer');
}

export function isTermsCheckboxMandatoryAndUnchecked() {
  if (document.getElementById('HasAgree') && !isCheckboxChecked('HasAgree')) {
    return true;
  }

  if (document.getElementById('ATTermsConditionsAgreed') && !isCheckboxChecked('ATTermsConditionsAgreed')) {
    return true;
  }

  return false;
}

export function isMandatoryHopRegistrationCheckboxUnchecked() {
  return isDobDisclaimerMandatoryAndUnchecked() || isTermsCheckboxMandatoryAndUnchecked();
}

export function isHopRegistrationBirthdateInvalid() {
  const dayInput = document.getElementById('dob-day');
  if (!dayInput) {
    return false;
  }

  const day = dayInput.value;
  const month = document.getElementById('dob-month')?.value ?? '';
  const year = document.getElementById('dob-year')?.value ?? '';

  return Boolean(getBirthdateValidationError(day, month, year));
}

export function isRequireOnePhoneUnmet() {
  const homePhone = document.getElementById('HomePhone');
  const mobilePhone = document.getElementById('MobilePhone');

  if (!homePhone && !mobilePhone) {
    return false;
  }

  const homeValue = homePhone?.value.trim() ?? '';
  const mobileValue = mobilePhone?.value.trim() ?? '';

  return homeValue === '' && mobileValue === '';
}

/** @deprecated Use isRequireOnePhoneUnmet */
export function isHopRegistrationPhoneInvalid() {
  return isRequireOnePhoneUnmet();
}

export function areRequiredHopRegistrationFieldsEmpty() {
  const form = document.getElementById('hop-registration-form');
  if (!form) {
    return false;
  }

  return Array.from(form.querySelectorAll('input, select, textarea')).some((field) => {
    if (!isVisibleFormField(field)) {
      return false;
    }

    return field.getAttribute('data-val-required') === 'true' && field.value.trim() === '';
  });
}

export function isHopRegistrationJqueryValidationFailed() {
  const jQuery = window.jQuery || window.$;
  const form = jQuery?.('#hop-registration-form');
  const validator = form?.data('validator');

  if (!validator) {
    return false;
  }

  const isInvalid = !validator.checkForm();
  clearHopRegistrationDobInputErrors();
  return isInvalid;
}

export function shouldDisableHopRegistrationSubmit() {
  const form = document.getElementById('hop-registration-form');
  if (!form) {
    return false;
  }

  return (
    isDobDisclaimerMandatoryAndUnchecked()
    || isTermsCheckboxMandatoryAndUnchecked()
    || isHopRegistrationBirthdateInvalid()
    || isRequireOnePhoneUnmet()
    || areRequiredHopRegistrationFieldsEmpty()
    || isHopRegistrationJqueryValidationFailed()
  );
}

export function syncHopRegistrationSubmitButton() {
  const submitButton = document.getElementById('submit_concession');
  const form = document.getElementById('hop-registration-form');

  if (!submitButton || !form) {
    return;
  }

  submitButton.disabled = shouldDisableHopRegistrationSubmit();
}

function dispatchSubmitButtonValidationEvent() {
  const EventConstructor = typeof CustomEvent === 'function'
    ? CustomEvent
    : document.defaultView?.CustomEvent ?? Event;

  document.dispatchEvent(new EventConstructor(submitButtonValidationEvent));
}

export function requestSubmitButtonValidation() {
  clearHopRegistrationDobInputErrors();
  syncHopRegistrationSubmitButton();
  dispatchSubmitButtonValidationEvent();
  syncHopRegistrationSubmitButton();
}
